import {combineReducers} from "redux";
import {AuthState} from "../actions/auth";
import {authReducer} from "./auth";
import {PlansState} from "../actions/plans";
import {plansReducer} from "./plans";
import {CheckoutState} from "../actions/checkout";
import {checkoutReducer} from "./checkout";
import {StudioState} from "../actions/studio";
import {studioReducer} from "./studio";
import {colorsReducer} from "./colors";
import {ColorsState} from "../actions/colors";
import {MemberState} from "../actions/session_member";
import { memberReducer } from "./member";

export interface StoreState {
    auth: AuthState
    checkout: CheckoutState
    plans: PlansState
    member: MemberState
    studio: StudioState
    colors: ColorsState
}

export const rootReducer = combineReducers({
    auth: authReducer,
    checkout: checkoutReducer,
    plans: plansReducer,
    member: memberReducer,
    studio: studioReducer,
    colors: colorsReducer,
})